import React from 'react'
import { withTheme } from 'modules/util'
import {
  iconClaim,
  iconCounterargument,
  iconEvidence,
  iconReasoning
} from 'modules/ui/assets'

import elementTheme from './theme.scss'

const icons = {
  claim: iconClaim,
  counterargument: iconCounterargument,
  evidence: iconEvidence,
  reasoning: iconReasoning
}

export function Element({ text, theme, type }) {
  return (
    <div className={theme.element}>
      <img alt={type} className={theme.icon} src={icons[type]} />

      <div>
        <span className={theme.label}>
          {type}
        </span>

        <span className={theme.text}>
          {text}
        </span>
      </div>
    </div>
  )
}

export default withTheme(elementTheme, Element)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Element/index.js